import ScrollAnimation from "react-animate-on-scroll";

import { Container } from "./styles";
import ProfileImg from "../../assets/profile.jpg";

export function Hero() {
  return (
    <Container
      id="home"
      style={{ justifyContent: "flex-start", alignItems: "center" }}
    >
      <div className="hero-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.5 * 1000}>
          <img
            src={ProfileImg}
            alt="Me"
            style={{ borderRadius: "50%", filter: "grayscale(1)" }}
          />
        </ScrollAnimation>
      </div>
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
          <p style={{ letterSpacing: 4 }}>Hi there! I am</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>Paola Consorti</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
          <h3 style={{ fontSize: "193%" }}>Graphic & UI/UX Designer</h3>
        </ScrollAnimation>
        {/* <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">
            Sou um técnico em informática com foco em desenvolvimento Web com
            JavaScript.
          </p>
        </ScrollAnimation> */}

        {/* <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <BrowserRouter>
            <NavHashLink smooth to="#contact" className="button">
              Contact
            </NavHashLink>
          </BrowserRouter>
        </ScrollAnimation> */}
      </div>
    </Container>
  );
}
